<template>
    <form id="register-form">
        <h1>Sign Up!</h1>
        <input type="text" placeholder="User Name..." v-model="alias" @change="errors = []" :disabled="isSaving"/>
        <input type="text" placeholder="Email..." v-model="email" @change="errors = []" :disabled="isSaving"/>
        <input type="password" placeholder="Password..." v-model="password" @change="errors = []" :disabled="isSaving"/>
        <input type="password" placeholder="Verify Password..." v-model="passwordVerify" @change="errors = []" :disabled="isSaving"/>

        <div class="gender-switcher">
            <input type="radio" id="gender-male" name="gender" value="Male" v-model="gender"/>
            <label for="gender-male">Male</label>

            <input type="radio" id="gender-female" name="gender" value="Female" v-model="gender"/>
            <label for="gender-female">Female</label>
        </div>


        <div class="agree-to-toc checkbox-row">
            <input type="checkbox" id="agree-check" v-model="agreesToToc" @change="errors = []" :disabled="isSaving"/>
            <label for="agree-check" class="fake-checkbox"></label>
            <label for="agree-check" class="checkbox-description">I agree with the
                <a href="/Doc/TOC" target="_blank">Terms & Conditions</a>
                and
                <a href="/Doc/PrivacyPolicy" target="_blank">Privacy Policy</a>
            </label>
        </div>

        <div class="agree-to-age checkbox-row">
            <input type="checkbox" id="agree-age" v-model="agreesToAge" @change="errors = []" :disabled="isSaving"/>
            <label for="agree-age" class="fake-checkbox"></label>
            <label for="agree-age" class="checkbox-description">I am 13+ years old</label>
        </div>

        <div class="validation error" v-if="errors.length > 0">
            <span v-for="error in errors">{{error}}</span>
        </div>

        <button @click.prevent="submit" :disabled="isSaving">Register</button>
    </form>
</template>

<script>
    import validator from 'validator';
    import axios from 'axios';

    export default {
        name: 'RegisterForm',

        data() {
            return {
                errors: [],
                isSaving: false,
                alias: '',
                email: '',
                password: '',
                passwordVerify: '',
                gender: 'Male',
                agreesToToc: false,
                agreesToAge: false
            }
        },

        methods: {
            submit(){
                let errors = [];

                this.alias = this.alias.trim();
                this.email = this.email.trim();

                if (this.alias.trim() === '') {
                    errors.push('No User Name Entered');
                }

                if (!validator.isEmail(this.email)) {
                    errors.push('Invalid Email Address');
                }
                if (this.password === '') {
                    errors.push('No Password Entered');
                } else if (this.password !== this.passwordVerify) {
                    errors.push('Passwords Don\'t Match');
                }

                if (!this.agreesToToc) {
                    errors.push("You Must Agree to the Terms and Conditions")
                }

                if (!this.agreesToAge) {
                    errors.push("You Must be 13+ years old")
                }

                if (errors.length > 0) {
                    this.errors = errors;
                    return;
                }

                this.isSaving = true;

                axios.post('/api/register', {
                    alias: this.alias,
                    email: this.email,
                    password: this.password,
                    gender: this.gender
                }).then(
                    (response) => {
                        if (response.data.errors) {
                            this.isSaving = false;
                            this.errors = response.data.errors;
                            return;
                        }

                        this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo', () => {
                            this.$socket.emit("setUserSocketData", this.$store.state.loggedUserModel.info);
                            this.$router.push('/Chat');
                        });
                    },
                    (response) => {
                        this.isSaving = false;
                        this.errors = ['There was a problem connecting to the Database. Please wait a minute and try again.'];
                    }
                )
            }
        }
    }
</script>


// WEBPACK FOOTER //
// RegisterForm.vue?56b72d40